import { copyParty } from '@/core';
import createSubOrder from '../createSubOrder';
import deepCopy from 'deepcopy';

export default function createTripOrder(order, trip, etd, eta, despatchOption = 'despatchParty', deliveryOption = 'deliveryParty', despatch = null, delivery = null, loadingSeqNo = 0) {
	switch (despatchOption) {
	case 'despatchParty': despatch = deepCopy(order.despatchParty); break;
	case 'trip': despatch = deepCopy(trip.fromAddress); break;
	case 'custom': break;
	default: break;
	}
	switch (deliveryOption) {
	case 'deliveryParty': delivery = deepCopy(order.deliveryParty); break;
	case 'trip': delivery = deepCopy(trip.toAddress); break;
	case 'custom': break;
	default: break;
	}

	let newOrder = {
		...createSubOrder(order),
		deliveryOption: deliveryOption,
		deliveryParty: copyParty(delivery),
		despatchOption: despatchOption,
		despatchParty: copyParty(despatch),
		tripId: trip.id,
		tripNumber: trip.tripNumber,
		vendor: trip.vendor,
		etd: etd ? etd : deepCopy(trip.etd),
		eta: eta ? eta : deepCopy(trip.eta),
		loadingSeqNo: loadingSeqNo
	};

	if (order.atd) {
		newOrder.atd = deepCopy(order.atd);
	}
	if (order.ata) {
		newOrder.ata = deepCopy(order.ata);
	}


	return newOrder;
}